import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdatePlayer from '@/modules/manage-player/api/hooks/useMutationUpdatePlayer'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'
import { GetPlayerListTableData } from '@/modules/manage-player/type'
import { useQueryClient } from '@tanstack/react-query'

interface BypassLinePlayerProps {
	row: GetPlayerListTableData
}

export function BypassLinePlayer({ row }: BypassLinePlayerProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updatePlayer } = useMutationUpdatePlayer()

	const handleMutate = async (value: boolean) => {
		await updatePlayer({
			id: row.id,
			payload: {
				bypassLine: value,
			},
		})

		// Invalidate queries to refresh the data
		queryClient.invalidateQueries({
			queryKey: [PlayerQueryKeys.GetPlayerList],
		})
	}

	return (
		<SetIsActive
			defaultChecked={row.bypassLine ?? false}
			onMutate={handleMutate}
			errorMessage="ไม่สามารถอัพเดทการข้าม LINE ได้"
		/>
	)
}
